import React from 'react';
import './inputwithicon.scss';

function InputWithIcon({ placeholderText, children, onSubmit, styles, ...rest }) {
  return (
    <div className="search" style={styles}>
      <input type="text" placeholder={placeholderText} {...rest} />
      {children}
      {/* <button>{children}</button> */}
    </div>
  );
}

export default InputWithIcon;
